import styled from "styled-components";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { entityGet } from "../../helpers/filter";
import { Loader, Segment, Statistic } from "semantic-ui-react";
import { getBillingForecast } from "../../redux/modules/billing-forecast";
import { t } from "../../constant/translations";
import { Currency } from "../common/currency";

const StyledStatiscticWrapper = styled.div`
  padding: 10px;
`;

const StyledSegment = styled(Segment)({
  display: "flex",
  "justify-content": "space-between",
  "@media (max-width: 600px)": {
    "flex-direction": "column",
    "text-align": "center",
  },
});

const EstateHeaderComponent = ({ estate }) => {
  const forecast = useSelector((state) =>
    entityGet(
      state.billingForecast.entities || [],
      (entry) => entry.estate.id === estate.id
    )
  );
  const loading = useSelector((state) => state.billingForecast.pending);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!forecast) {
      dispatch(getBillingForecast(estate.id));
    }
  }, [forecast, estate.id, dispatch]);

  if (loading) {
    return <Loader active={true} />;
  }

  return (
    <StyledSegment>
      <StyledStatiscticWrapper>
        <Statistic
          label={t("estate.inst_to")}
          value={
            <Statistic.Value>
              <Currency amount={forecast ? forecast.total : "--"} />
            </Statistic.Value>
          }
          size="mini"
        />
      </StyledStatiscticWrapper>
      <StyledStatiscticWrapper>
        <Statistic
          label={t("block.current_liabilities")}
          value={
            <Statistic.Value>
              <Currency amount={estate.debt} className={"value"} />
            </Statistic.Value>
          }
          size="mini"
        />
      </StyledStatiscticWrapper>
      <StyledStatiscticWrapper>
        <Statistic
          label={t("charge.balance")}
          value={
            <Statistic.Value>
              <Currency amount={estate.balance} className={"value"} />
            </Statistic.Value>
          }
          size="mini"
        />
      </StyledStatiscticWrapper>
    </StyledSegment>
  );
};

EstateHeaderComponent.propTypes = {
  estate: PropTypes.object.isRequired,
};

export const DetailsHeader = EstateHeaderComponent;
